import axios from 'axios'
import { envConfig } from '../../env-config'

const unleashProxy = axios.create({
  baseURL: envConfig.unleashProxyUrl,
})

export async function getFeatureFlag(userId, flag) {
  const response = await unleashProxy.post(`/flags?userId=${userId}`, {
    toggles: [flag],
  })

  return response.data
}

export async function getAllFeatureFlags(userId) {
  const response = await unleashProxy.get(`/flags?userId=${userId}`)

  return response.data
}

export default unleashProxy
